<script>
  import ClickOut from '../../../../utils/directives/clickout'

  export default {
    name: 'filtros-lote',
    data () {
      return {
        open: false
      }
    },
    computed: {},
    mounted () {
    },
    destroyed () {
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      hide () {
        this.open = false
      }
    },
    components: {},
    directives: {ClickOut}
  }
</script>

<template>
  <div class="btn-group dropdown" :class="{ open: open}" v-click-out="hide">
    <button class="btn btn-default btn-sm" data-toggle="dropdown" aria-expanded="false" @click="toggle">
      Filtros <span class="caret"></span></button>
    <ul class="dropdown-menu">
      <li><a>Data de criação <i class="fa fa-check pos-abs pos-r-sm tex-small m-t-xs sort-by-check inline"></i></a></li>
      <li><a>Data de abertura</a></li>
      <li><a>Data de fechamento</a></li>
      <li><a>Nome</a></li>
      <li class="divider"></li>
      <li><a>Ordem Crescente</a></li>
      <li><a>Ordem Decrescente <i
        class="fa fa-check pos-abs pos-r-sm txt-small m-t-xs sort-by-check inline"></i></a></li>
    </ul>
  </div>
</template>



// WEBPACK FOOTER //
// FiltroLote.vue?054e2a62